import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spanishDate',
})
export class SpanishDatePipe implements PipeTransform {
  private months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ];

  transform(value: Date | string): string {
    if (!value) return '';

    let date: Date;

    if (typeof value === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
      // Formato DD/MM/YYYY
      const [day, month, year] = value.split('/').map(Number);
      date = new Date(year, month - 1, day);
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return '';

    const day = date.getDate();
    const month = this.months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} de ${month} del ${year}`;
  }
}
